/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { VideoDocument } from '@gql/graphql'
import VideoTutorialDetailTemplate from '@components/templates/VideoTutorialDetailTemplate/VideoTutorialDetailTemplate'

const VideoDetail = ({ pagina, video, mainContent }) => {
  return (
    <VideoTutorialDetailTemplate pagina={pagina} videoTutorial={video} mainContent={mainContent} />
  )
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/informazioni-utili/video-tutorial/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { video },
    } = await client.query({
      query: VideoDocument,
      variables: { slug, preview },
      context: {
        headers,
      },
    })

    if (!video) {
      return {
        notFound: true,
      }
    }

    const mainContent = video?.pagebuilders?.find((x) => x.key === 'main') ?? null

    return {
      props: {
        pagina: video.pagina,
        video,
        mainContent,
        key: video.pk,
      },
      revalidate: 60 * 20,
    }
  },
  '/informazioni-utili/video-tutorial/[slug]'
)

export default VideoDetail
